import React, { useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaHome } from "react-icons/fa";
import { RiContactsBookUploadLine } from "react-icons/ri";
import { AiOutlineFilePdf } from "react-icons/ai";
import { MdAccountBalanceWallet } from "react-icons/md";
import { setActiveBusiness, logout } from "../../redux/authStore/slice";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { businesses: rawBusinesses, selectedBusiness } = useSelector(
    (state) => state.auth || {}
  );

  const businesses = useMemo(
    () => (Array.isArray(rawBusinesses) ? rawBusinesses : []),
    [rawBusinesses]
  );
  const selectedBusinessId = selectedBusiness?._id || "";

  useEffect(() => {
    if (!selectedBusinessId && businesses.length > 0) {
      dispatch(setActiveBusiness(businesses[0]));
    }
  }, [selectedBusinessId, businesses, dispatch]);

  const handleBusinessChange = (event) => {
    const businessId = event.target.value;
    const business = businesses.find((item) => item._id === businessId) || null;
    dispatch(setActiveBusiness(business));
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <aside
      className="d-none d-md-flex bg-light border-end flex-shrink-0 p-1 mb-3 mb-md-0 flex-column h-100"
      style={{ width: "100%", maxWidth: "250px" }}
    >
      <div className="px-2">
        <div className="mb-3">
          <label
            htmlFor="businessSwitcher"
            className="form-label small text-uppercase text-muted fw-semibold mb-1"
          >
            Business
          </label>
          <select
            id="businessSwitcher"
            className="form-select form-select-sm"
            value={selectedBusinessId}
            onChange={handleBusinessChange}
            disabled={businesses.length <= 1}
          >
            {businesses.length === 0 ? (
              <option value="">No businesses found</option>
            ) : (
              businesses.map((business) => (
                <option key={business._id} value={business._id}>
                  {business.businessName}
                </option>
              ))
            )}
          </select>
          {businesses.length <= 1 ? (
            <small className="text-muted d-block mt-1">
              {businesses.length === 0
                ? "Create a business after login to enable switching."
                : "Only one business available."}
            </small>
          ) : null}
        </div>
      </div>
      <div style={{ paddingTop: "10px" }} className="mt-2 px-2 flex-grow-1 overflow-auto">
        <ul className="nav flex-column">
          <li className="nav-item">
            <NavLink
              to="/dashboard"
              end
              className={({ isActive }) =>
                `nav-link d-flex align-items-center py-2 ${
                  isActive
                    ? "active bg-primary-subtle text-primary fw-semibold"
                    : "text-dark"
                }`
              }
            >
              <FaHome className="me-2" /> Dashboard
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center py-2 ${
                  isActive
                    ? "active bg-primary-subtle text-primary fw-semibold"
                    : "text-dark"
                }`
              }
            >
              <RiContactsBookUploadLine className="me-2" /> Contact
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/file-store"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center py-2 ${
                  isActive
                    ? "active bg-primary-subtle text-primary fw-semibold"
                    : "text-dark"
                }`
              }
            >
              <AiOutlineFilePdf className="me-2" /> File Store
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/ledger"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center py-2 ${
                  isActive
                    ? "active bg-primary-subtle text-primary fw-semibold"
                    : "text-dark"
                }`
              }
            >
              <MdAccountBalanceWallet className="me-2" /> Ledger
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="px-2 pb-3 mt-auto">
        <button type="button" className="btn btn-outline-danger w-100" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
